var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addCode" },
    [
      _c(
        "custom-box",
        {
          class: { "mobile-custom-box": _vm.isMobile },
          attrs: {
            title: _vm.paramsData.serverID
              ? _vm.$t("modifyServer")
              : _vm.$t("addServer"),
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              class: { "mobile-form": _vm.isMobile },
              attrs: {
                "label-position": "left",
                model: _vm.paramsData,
                rules: _vm.rules,
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "serverName", label: _vm.$t("serverName") }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.serverName,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "serverName", $$v)
                      },
                      expression: "paramsData.serverName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "config_state", label: _vm.$t("serverStatus") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.config_state,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "config_state", $$v)
                        },
                        expression: "paramsData.config_state"
                      }
                    },
                    _vm._l(_vm.configState, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "is_timing", label: _vm.$t("scheduledModify") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.is_timing,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_timing", $$v)
                        },
                        expression: "paramsData.is_timing"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: _vm.$t("yes"), value: 1 }
                      }),
                      _c("el-option", {
                        attrs: { label: _vm.$t("no"), value: 2 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.paramsData.is_timing == 1
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: {
                        prop: "time_to_run",
                        label: _vm.$t("scheduledTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "popper-class": "no-atTheMoment",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetime",
                          placeholder: _vm.$t("date")
                        },
                        model: {
                          value: _vm.paramsData.time_to_run,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "time_to_run", $$v)
                          },
                          expression: "paramsData.time_to_run"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "new_tag", label: _vm.$t("isNewServer") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.new_tag,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "new_tag", $$v)
                        },
                        expression: "paramsData.new_tag"
                      }
                    },
                    _vm._l(_vm.newTag, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "is_recomm",
                    label: _vm.$t("recommendServerTag")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.is_recomm,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_recomm", $$v)
                        },
                        expression: "paramsData.is_recomm"
                      }
                    },
                    _vm._l(_vm.recommList, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  staticStyle: { width: "100%" },
                  attrs: { label: _vm.$t("serverPushMessage") }
                },
                [
                  _c(
                    "div",
                    { staticClass: "y-start", staticStyle: { width: "100%" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex first_box lodingItem-title",
                          class: { "mobile-content-header": _vm.isMobile },
                          staticStyle: {
                            "margin-bottom": "10px",
                            width: "100%",
                            "align-items": "center"
                          }
                        },
                        _vm._l(_vm.tagList, function(items, indexs) {
                          return _c(
                            "div",
                            {
                              key: indexs,
                              staticClass: "addtag",
                              on: {
                                click: function($event) {
                                  return _vm.addtag(items.content, _vm.index)
                                }
                              }
                            },
                            [_vm._v(_vm._s(items.name))]
                          )
                        }),
                        0
                      ),
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 12 },
                          placeholder: _vm.$t("pleaseInput")
                        },
                        model: {
                          value: _vm.paramsData.push_msg,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "push_msg", $$v)
                          },
                          expression: "paramsData.push_msg "
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("submit")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }